export const getGradientStops = (
  value: number
): { startColor: string; endColor: string } => {
  // Error handling: Check if value is valid
  if (typeof value !== 'number' || isNaN(value)) {
    // Return default Red-Purple for safety
    return {
      startColor: '#D33F25',
      endColor: '#663FDA'
    };
  }

  switch (true) {
    case value <= 30:
      return {
        startColor: '#D33F25',
        endColor: '#663FDA'
      };
    case value <= 50:
      return {
        startColor: '#FF8A00',
        endColor: '#FFB347'
      };
    case value <= 70:
      return {
        startColor: '#E5D135',
        endColor: '#CF804F'
      };
    case value <= 90:
      return {
        startColor: '#25D3B1',
        endColor: '#6EE7B7'
      };
    case value > 90:
    default:
      return {
        startColor: '#25D3B1',
        endColor: '#6544C8'
      };
  }
};

export const getProgressMode = (progressValue: number): string => {
  if (progressValue >= 0 && progressValue <= 50) {
    return 'Poor';
  } else if (progressValue >= 51 && progressValue <= 65) {
    return 'Needs Work';
  } else if (progressValue >= 66 && progressValue <= 75) {
    return 'Fair';
  } else if (progressValue >= 76 && progressValue <= 94) {
    return 'Good';
  } else if (progressValue >= 95 && progressValue <= 100) {
    return 'Excellent';
  } else {
    return 'Invalid Score'; // For out-of-range values
  }
};

export const getPromptPercentageChipColor = (value: number) => {
  if (value <= 50) {
    return {
      color: '#F59E0B',
      backgroundColor: '#F59E0B1A'
    };
  }
  if (value <= 79) {
    return {
      color: '#361B87',
      backgroundColor: '#361B871A'
    };
  }
  return {
    color: '#1A927B',
    backgroundColor: '#ECFDF3'
  };
};
